import {
    Component,
    OnInit,
    Input,
    forwardRef,
    NgModule,
    TemplateRef,
    Output,
    EventEmitter,
    ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { Subject } from 'rxjs/Rx';
import { ApiService } from '../services/api.service';

declare let _;

export interface GoodOpt {
    name: string;
    goodId?: string;
    disabled?: boolean;
}

export interface DomOpt {
    _value: string;
    _label: string;
}

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => StandardGoodComponent),
    multi: true
};
export class StandardGoodComponent implements ControlValueAccessor, OnInit {
     domOpt: DomOpt;
private onTouchedCallback: () => () => {};
private onChangeCallback: (_: any) => () => {};

    options: Array<GoodOpt> = [];
    // 单选的时候传字符串，多选传数组
    _value: string;
    _width = "100%";
    _content: TemplateRef<any>;
    _allowClear = true;
    _nzMode = "combobox";
    // 下拉过滤含关键字选项，false为不过滤
    _filter = false;
    _placeholder = ""
    currentText = "";
    firstNum = 1;
    canQuery = true;
    loading = false;
    keyWordStream = new Subject<string>()
    keyWord$: any;

     goodId = "";
     placeholder = "请选择品名";
     rowsNum = 10;
     valueType = "";
     nzDisabled = false;
/**
 * @param {?} v
 * @return {?}
 */
set value(v: any) {
        if (!v) {
            this.canQuery = true;
            this.firstNum = 1;
            this.queryData('', []);
            this.onChangeCallback({});
            return;
        }
        // 防止重复赋值
        if (_.isEqual(this._value, v)) return;
        this._value = v;
        // 双向绑定获取对象
        if (this.valueType === "object") {
            this.onChangeCallback(v);
        } else if(this.valueType === "objectString") {
            this.onChangeCallback(`{standProductName: ${v.name}, standProductId: ${v.code}}`)
        } else {
            const /** @type {?} */ innerValue = this._allowClear ? (v.goodId || "") : ( /** @type {?} */((<Array<any>>v.map(val => val.goodId))) || []);
            this.onChangeCallback(innerValue);
        }

    }
/**
 * @return {?}
 */
get value(): any {
        return this._value;
    };
/**
 * @param {?} v
 * @return {?}
 */
set width(v: any) {
        const /** @type {?} */ width = parseInt(v);
        this._width = ( /** @type {?} */((<any>Array.from(v)))).includes("%") ? `${v}%` : isNaN(width) ? this._width : `${width}px`;
    }
/**
 * @param {?} v
 * @return {?}
 */
set goodMode(v) {
        this._nzMode = v;
        this._allowClear = v === "combobox" ? true : false;
    };
/**
 * @param {?} tpl
 * @return {?}
 */
set customTemplate(tpl: TemplateRef<any>) {
        if (tpl instanceof TemplateRef) {
            this._content = tpl;
        }
    }

     openChange = new EventEmitter();
     onChange = new EventEmitter();
/**
 * @param {?} api
 */
constructor(private api: ApiService) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        // 限流
        this.keyWord$ = this.keyWordStream
            .debounceTime(250)
            .subscribe(word => {
                this.queryData(word, []);
            });
        this._placeholder = this.placeholder;
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: any) {
        if (changes.goodId && this.goodId) {
            this.firstNum = 1;
            this.loading = true;
            this.queryData(this.goodId, [], true);
        }
        if (changes.customerId) {
            this.firstNum = 1;
            this.loading = true;
            this.canQuery = true;
            this.queryData(this.goodId, []);
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.keyWord$.unsubscribe()
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this._value) {
            this._value = value;
            if (value) {
                this.currentText = value.name;
                this.firstNum = 1;
                this.loading = true;
                this._placeholder = '';
                if (value.name) {
                    this.queryData(value.name, [], true);
                } else {
                    this.queryData(value, [], true);
                }
            }
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * @param {?} event
 * @return {?}
 */
yztSearchChange(event) {
        this.canQuery = true;
        this.currentText = event;
        this.firstNum = 1;
        this.keyWordStream.next(event);
    }
/**
 * @return {?}
 */
yztScrollToBottom() {
        this.queryData(this.currentText, this.options);
    }
/**
 * 仅作清空多选选项
 * @param {?=} $event
 * @return {?}
 */
clearSelect($event?: MouseEvent): void {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this.options = [];
        this.value = '';
    }
/**
 * 查询数据
 * @param {?=} searchText
 * @param {?=} options
 * @param {?=} firstIn
 * @return {?}
 */
queryData(searchText?: string, options?: Array<GoodOpt>, firstIn: boolean = false) {
        if (!this.canQuery) return;
        const /** @type {?} */ goodName = searchText;
        let /** @type {?} */ params;
        if(this.goodId) {
            params = [{ "page": this.firstNum, "size": this.rowsNum }, { code: this.goodId }];
        } else {
            params = [{ "page": this.firstNum, "size": this.rowsNum }, { name: goodName }];
        }
        this.api.getStandarGood( /** @type {?} */((params as any))).subscribe(json => {
            let /** @type {?} */ content = json && json['content'] || {};
            let /** @type {?} */ result = content['content'] || []

            this.options = options.concat(result);
            this.firstNum += 1;
            if (firstIn || this.goodId) {
                this.value = this.options[0];
            }
            this.loading = false;
            this._placeholder = this.placeholder;

            if (!result.length) {
                this.options.push({ goodId: "empty", name: "没有更多选项！", disabled: true });
                this.canQuery = false;
            }
        })
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: `standard-good`,
    template: `
    <div class="good-select">
        <nz-select 
            class="good-nz-select"
            [style.width]="_width" 
            [nzPlaceHolder]="_placeholder" 
            [nzMode]="_nzMode"
            [nzFilter]="_filter"
            [nzAllowClear]="_allowClear"
            (nzScrollToBottom)="yztScrollToBottom()"
            (nzSearchChange)="yztSearchChange($event)"
            [nzDisabled]="nzDisabled"
            [(ngModel)]="value">
            <nz-option
                #domOpt
                *ngFor="let option of options"
                [nzLabel]="option.name"
                [nzValue]="option"
                [nzDisabled]="option.disabled">
                <ng-template *ngIf="_content" #nzOptionTemplate>
                    <ng-container [ngTemplateOutlet]="_content" [ngTemplateOutletContext]="option"></ng-container>
                </ng-template>
            </nz-option>
        </nz-select>
        <span
          role="close-icon"
          (click)="clearSelect($event)"
          class="ant-select-selection__clear close-icon"
          style="-webkit-user-select: none;"
          *ngIf="!_allowClear&&options.length">
        </span>
        <span class="echo-loading" *ngIf="loading"><i class="anticon anticon-loading anticon-spin loading-pos"></i></span>
    </div>
    `,
    styles: [`
        .close-icon {
            opacity: 0;
            position: absolute;
            right: 20px;
            top: 50%;
            margin-top: -10px;
        }
        .close-icon:hover {
            opacity: 1;
        }
        .good-nz-select:hover +.close-icon {
            opacity: 1;
        }
        .good-select {
            position: relative;
        }
        .echo-loading {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            min-height: 28px;
        }
        .loading-pos {
            position: absolute;
            left: 10px;
            top: 6px;
        }
    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApiService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'domOpt': [{ type: ViewChild, args: ["domOpt", ] },],
'goodId': [{ type: Input },],
'placeholder': [{ type: Input },],
'rowsNum': [{ type: Input },],
'valueType': [{ type: Input },],
'nzDisabled': [{ type: Input },],
'width': [{ type: Input },],
'goodMode': [{ type: Input },],
'customTemplate': [{ type: Input },],
'openChange': [{ type: Output },],
'onChange': [{ type: Output },],
};
}

function StandardGoodComponent_tsickle_Closure_declarations() {
/** @type {?} */
StandardGoodComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StandardGoodComponent.ctorParameters;
/** @type {?} */
StandardGoodComponent.propDecorators;
/** @type {?} */
StandardGoodComponent.prototype.domOpt;
/** @type {?} */
StandardGoodComponent.prototype.onTouchedCallback;
/** @type {?} */
StandardGoodComponent.prototype.onChangeCallback;
/** @type {?} */
StandardGoodComponent.prototype.options;
/** @type {?} */
StandardGoodComponent.prototype._value;
/** @type {?} */
StandardGoodComponent.prototype._width;
/** @type {?} */
StandardGoodComponent.prototype._content;
/** @type {?} */
StandardGoodComponent.prototype._allowClear;
/** @type {?} */
StandardGoodComponent.prototype._nzMode;
/** @type {?} */
StandardGoodComponent.prototype._filter;
/** @type {?} */
StandardGoodComponent.prototype._placeholder;
/** @type {?} */
StandardGoodComponent.prototype.currentText;
/** @type {?} */
StandardGoodComponent.prototype.firstNum;
/** @type {?} */
StandardGoodComponent.prototype.canQuery;
/** @type {?} */
StandardGoodComponent.prototype.loading;
/** @type {?} */
StandardGoodComponent.prototype.keyWordStream;
/** @type {?} */
StandardGoodComponent.prototype.keyWord$;
/** @type {?} */
StandardGoodComponent.prototype.goodId;
/** @type {?} */
StandardGoodComponent.prototype.placeholder;
/** @type {?} */
StandardGoodComponent.prototype.rowsNum;
/** @type {?} */
StandardGoodComponent.prototype.valueType;
/** @type {?} */
StandardGoodComponent.prototype.nzDisabled;
/** @type {?} */
StandardGoodComponent.prototype.openChange;
/** @type {?} */
StandardGoodComponent.prototype.onChange;
/** @type {?} */
StandardGoodComponent.prototype.api;
}

export class StandardGoodModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule,
    ],
    declarations: [
        StandardGoodComponent
    ],
    exports: [StandardGoodComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function StandardGoodModule_tsickle_Closure_declarations() {
/** @type {?} */
StandardGoodModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StandardGoodModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
